/**
 * Debug utility for conditional logging
 *
 * Set VITE_DEBUG=true in .env to enable debug logs in production builds
 */

const isDevelopment = import.meta.env.DEV
const isDebugEnabled = import.meta.env.VITE_DEBUG === "true"

/**
 * Log debug messages (only in development or when VITE_DEBUG=true)
 */
export function debug(...args: unknown[]) {
  if (isDevelopment || isDebugEnabled) {
    console.log(...args)
  }
}

/**
 * Log warnings (always enabled)
 */
export function warn(...args: unknown[]) {
  console.warn(...args)
}

/**
 * Log errors (always enabled)
 */
export function error(...args: unknown[]) {
  console.error(...args)
}

/**
 * Log info messages (always enabled)
 */
export function info(...args: unknown[]) {
  console.info(...args)
}
